import { dataHooks as wixDataHooks } from '@wix/data-hooks'

export const dataHooks = wixDataHooks<{
  template: {}
  radio: { index: number }
  nextButton: {}
}>('headless-radio-input')
